import React from "react";
import "fontsource-roboto";
import { Provider } from "react-redux";
import { BrowserRouter as Router } from "react-router-dom";
import { createRoot } from "react-dom/client";
import store from "store";
import App from "App";
import reportWebVitals from "./reportWebVitals";
import "./index.css";
import axiosInitializer from "./helpers/axiosInitializer";

const container = document.getElementById("root");
const root = createRoot(container!);

// const persistor = persistStore(store);
axiosInitializer();

root.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <App />
      </Router>
    </Provider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals(console.log);
